import React, { useState } from 'react';
import { Input, Table, Typography } from 'antd';
import { CheckCircleTwoTone, CloseCircleTwoTone } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { getStockHistory } from '../../../actions/report';

const { Title } = Typography;

const StockHistoryPage = () => {
  const [title, setTitle] = useState('');
  const [attributes, setAttributes] = useState('');
  const [floatingTransfers, setFloatingTransfers] = useState([]);
  const [productStocks, setProductStocks] = useState([]);
  const [productEntries, setProductEntries] = useState([]);
  const [soldProducts, setSoldProducts] = useState([]);
  const [summary, setSummary] = useState(null);

  console.log('productEntries', productEntries)
  console.log('floatingTransfers', floatingTransfers)
  console.log('soldProducts', soldProducts)
  console.log('productStocks', productStocks)

  const dispatch = useDispatch();

  const handleSearch = async () => {
    const result = await dispatch(getStockHistory(title, attributes));
    if (result) {
      setFloatingTransfers(result.floating_transfers || []);
      setProductStocks(result.product_stocks || []);
      setProductEntries(result.product_entries || []);
      setSoldProducts(result.sold_products || []);
      setSummary(result.summary || null);
    }
  };

  const columnsFloating = [
    { title: 'Transfer Number', dataIndex: 'transfer_number', key: 'transfer_number' },
    { title: 'Source', dataIndex: 'source', key: 'source' },
    { title: 'Distance', dataIndex: 'destance', key: 'destance' },
    { title: 'Attributes', dataIndex: 'product_attributes', key: 'product_attributes' },
    { title: 'Quantity', dataIndex: 'quantity', key: 'quantity' },
  ];

  const columnsStock = [
    { title: 'Attribute Details', dataIndex: 'Attribute_details', key: 'Attribute_details' },
    { title: 'Warehouse', dataIndex: 'Warehouse_name', key: 'Warehouse_name' },
    { title: 'Category', dataIndex: 'category', key: 'category' },
    { title: 'Quantity', dataIndex: 'quantity', key: 'quantity' },
  ];

  const columnsEntry = [
    { title: 'Warehouse', dataIndex: ['ProductLocation', 'Warehouse_name'], key: 'Warehouse_name' },
    { title: 'Attribute Details', dataIndex: ['ProductLocation', 'Attribute_details'], key: 'attribute' },
    { title: 'Quantity', dataIndex: 'quantity', key: 'quantity' },
    { title: 'Created At', dataIndex: 'created', key: 'created' },
  ];

  const columnsSold = [
    { 
      title: 'Location', 
      dataIndex: 'location', 
      key: 'location', 
      render: (_, record) => (record.Product && record.Product.length > 0 && record.Product[0].Warehouse_name) ? record.Product[0].Warehouse_name : 'N/A' 
    },
    { title: 'Invoice', dataIndex: 'invoice', key: 'invoice' },
    { title: 'Details', dataIndex: 'Details', key: 'Details' },
    { title: 'Quantity', dataIndex: 'quantity', key: 'quantity' },
    { title: 'Issued Date', dataIndex: 'created_at', key: 'created_at' },
  ];

  const columnsSummary = [
    { title: 'Total Product Entries', dataIndex: 'total_entries', key: 'total_entries' },
    { title: 'Total Product Stocks', dataIndex: 'total_stocks', key: 'total_stocks' },
    { title: 'Floating Transfers', dataIndex: 'total_floating', key: 'total_floating' },
    { title: 'Sold Products', dataIndex: 'total_sold', key: 'total_sold' },
    {
      title: 'Balance Status',
      dataIndex: 'is_balanced',
      key: 'is_balanced',
      render: (is_balanced) =>
        is_balanced ? (
          <CheckCircleTwoTone twoToneColor="#52c41a" />
        ) : (
          <CloseCircleTwoTone twoToneColor="#ff4d4f" />
        ),
    },
  ];

  return (
    <div style={{ padding: 24 }}>
      <Title level={3}>Stock History Report</Title>
      <div style={{ display: 'flex', gap: '16px', marginBottom: 24 }}>
        <Input.Search
          placeholder="Search Product Title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          onSearch={handleSearch}
          enterButton
          style={{ width: 400 }}
        />
        <Input.Search
          placeholder="Search Attributes"
          value={attributes}
          onChange={(e) => setAttributes(e.target.value)}
          onSearch={handleSearch}
          enterButton
          style={{ width: 400 }}
        />
      </div>

      {summary && (
        <>
          <Title level={4}>Summary</Title>
          <Table
            dataSource={[
              {
                key: 'summary',
                total_entries: summary.total_entries,
                total_stocks: summary.total_stocks,
                total_floating: summary.total_floating,
                total_sold: summary.total_sold,
                is_balanced: summary.is_balanced,
              },
            ]}
            columns={columnsSummary}
            pagination={false}
            rowKey="key"
            style={{ marginBottom: 24 }}
          />
        </>
      )}

      <Title level={4}>Product Entries</Title>
      <Table dataSource={productEntries} columns={columnsEntry} rowKey="id" />

      <Title level={4}>Floating Transfers</Title>
      <Table dataSource={floatingTransfers} columns={columnsFloating} rowKey="id" />

      <Title level={4}>Sold Products</Title>
      <Table dataSource={soldProducts} columns={columnsSold} rowKey="id" />

      <Title level={4}>Product Stocks</Title>
      <Table dataSource={productStocks} columns={columnsStock} rowKey="id" />
    </div>
  );
};

export default StockHistoryPage;
